<script setup>
import { defineProps } from "vue";

const props = defineProps({
    iconURL: { type: String, required: true },
    headingTex: { type: String, required: true },
    subText: { type: String, required: true },
});
</script>

<template>
    <div class="relative flex flex-col items-center justify-center -mt-10">
        <div
            class="absolute w-[100px] h-[100px] border border-[#E4E7EC] rounded-full opacity-0.5"
        ></div>
        <div
            class="absolute w-120 h-120 border border-[#edeff3] rounded-full"
        ></div>
        <div
            class="absolute w-100 h-100 border border-[#E4E7EC] rounded-full"
        ></div>
        <div
            class="absolute w-80 h-80 border border-[#E4E7EC] rounded-full"
        ></div>
        <div
            class="absolute w-60 h-60 border border-[#E4E7EC] rounded-full"
        ></div>
        <div
            class="absolute w-40 h-40 border border-[#E4E7EC] rounded-full"
        ></div>
        <div
            class="absolute w-20 h-20 border border-[#E4E7EC] rounded-full"
        ></div>

        <div
            class="relative flex flex-col items-center justify-center w-32 h-32 rounded-full bg-white z-10 mt-16"
        >
            <img :src="iconURL" alt="Referral Icon" class="w-20 md:w-24" />
        </div>

        <div class="text-center mt-1 z-10">
            <h2 class="text-lg font-bold">{{ headingTex }}</h2>
            <p class="text-sm text-gray-600">{{ subText }}</p>
        </div>
    </div>
</template>
